var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTipFriendIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 49.5C19.306 49.5 15.5 45.694 15.5 41C15.5 38.515 17.515 36.5 20 36.5H28C30.485 36.5 32.5 38.515 32.5 41C32.5 45.694 28.694 49.5 24 49.5Z",
    stroke: "#131313",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48 49.5C43.306 49.5 39.5 45.694 39.5 41C39.5 38.515 41.515 36.5 44 36.5H52C54.485 36.5 56.5 38.515 56.5 41C56.5 45.694 52.694 49.5 48 49.5Z",
    stroke: "#131313",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 40.5002L21.203 27.6692C22.31 25.1782 25.573 24.5722 27.5 26.5002",
    stroke: "#131313",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5 40.5002L50.797 27.6692C49.69 25.1782 46.427 24.5722 44.5 26.5002",
    stroke: "#131313",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 36.5H42.5",
    stroke: "#131313",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5 42.5H39.5",
    stroke: "#131313",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 41C18.3284 41 19 40.3284 19 39.5C19 38.6716 18.3284 38 17.5 38C16.6716 38 16 38.6716 16 39.5C16 40.3284 16.6716 41 17.5 41Z",
    fill: "#131313"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 47C20.3284 47 21 46.3284 21 45.5C21 44.6716 20.3284 44 19.5 44C18.6716 44 18 44.6716 18 45.5C18 46.3284 18.6716 47 19.5 47Z",
    fill: "#131313"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 43C23.3284 43 24 42.3284 24 41.5C24 40.6716 23.3284 40 22.5 40C21.6716 40 21 40.6716 21 41.5C21 42.3284 21.6716 43 22.5 43Z",
    fill: "#131313"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5 39C26.3284 39 27 38.3284 27 37.5C27 36.6716 26.3284 36 25.5 36C24.6716 36 24 36.6716 24 37.5C24 38.3284 24.6716 39 25.5 39Z",
    fill: "#131313"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 49C25.3284 49 26 48.3284 26 47.5C26 46.6716 25.3284 46 24.5 46C23.6716 46 23 46.6716 23 47.5C23 48.3284 23.6716 49 24.5 49Z",
    fill: "#131313"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 45C28.3284 45 29 44.3284 29 43.5C29 42.6716 28.3284 42 27.5 42C26.6716 42 26 42.6716 26 43.5C26 44.3284 26.6716 45 27.5 45Z",
    fill: "#131313"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5 41C31.3284 41 32 40.3284 32 39.5C32 38.6716 31.3284 38 30.5 38C29.6716 38 29 38.6716 29 39.5C29 40.3284 29.6716 41 30.5 41Z",
    fill: "#131313"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5 41C42.3284 41 43 40.3284 43 39.5C43 38.6716 42.3284 38 41.5 38C40.6716 38 40 38.6716 40 39.5C40 40.3284 40.6716 41 41.5 41Z",
    fill: "#131313"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5 47C44.3284 47 45 46.3284 45 45.5C45 44.6716 44.3284 44 43.5 44C42.6716 44 42 44.6716 42 45.5C42 46.3284 42.6716 47 43.5 47Z",
    fill: "#131313"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5 43C47.3284 43 48 42.3284 48 41.5C48 40.6716 47.3284 40 46.5 40C45.6716 40 45 40.6716 45 41.5C45 42.3284 45.6716 43 46.5 43Z",
    fill: "#131313"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5 39C50.3284 39 51 38.3284 51 37.5C51 36.6716 50.3284 36 49.5 36C48.6716 36 48 36.6716 48 37.5C48 38.3284 48.6716 39 49.5 39Z",
    fill: "#131313"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5 49C49.3284 49 50 48.3284 50 47.5C50 46.6716 49.3284 46 48.5 46C47.6716 46 47 46.6716 47 47.5C47 48.3284 47.6716 49 48.5 49Z",
    fill: "#131313"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5 45C52.3284 45 53 44.3284 53 43.5C53 42.6716 52.3284 42 51.5 42C50.6716 42 50 42.6716 50 43.5C50 44.3284 50.6716 45 51.5 45Z",
    fill: "#131313"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M54.5 41C55.3284 41 56 40.3284 56 39.5C56 38.6716 55.3284 38 54.5 38C53.6716 38 53 38.6716 53 39.5C53 40.3284 53.6716 41 54.5 41Z",
    fill: "#131313"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 69,
    height: 69,
    rx: 34.5,
    stroke: "#131313",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTipFriendIcon);
export default __webpack_public_path__ + "static/media/tip-friend-icon.98a74d110d24f3e39b5c650ede7c4082.svg";
export { ForwardRef as ReactComponent };